<div class="@container" data-test-id="availability-widget">
	<div class="card card-no-padding card-elevation-5">
		@if (showAccommodationTypes() && accommodationTypes?.length > 1) {
			<vp-tab-menu [(activeTab)]="activeAccommodationType" color="white">
				<vp-tab-menu-item
					[label]="('global.all' | translate) || 'All'"
					[name]=""
				/>
				@for (item of accommodationTypes; track $index) {
					<vp-tab-menu-item
						[label]="item.name"
						[name]="item.accommodationType"
					/>
				}
			</vp-tab-menu>
		}
		<div class="card-inner-md flex flex-col gap-4 @lg:flex-row">
			<div class="empty:hidden @md:hidden" data-test-id="slot">
				<ng-content />
			</div>
			<div class="flex size-full flex-col @sm:flex-row children:flex-1">
				@if (showHotels() && hotels.length > 0) {
					<vp-availability-widget-input-dropdown
						[className]="
							cn(
								'focus:relative focus:z-10',
								(showPackages() ||
									showOccupancy() ||
									showDates()) &&
									'@max-md:-mb-px @max-sm:-mb-px @max-sm:rounded-b-none @sm:-mr-px @sm:rounded-r-none'
							)
						"
						[items]="hotels"
						[label]="'global.hotel' | translate"
						[placeholder]="
							'global.hotel-selection-placeholder' | translate
						"
						[(isOpen)]="isHotelsOpen"
						(emitCta)="onCtaEmit($event)"
						(itemSelected)="onHotelSelect($event)"
						data-test-id="hotels-selector"
						inputName="availability-hotels"
					/>
				}
				@if (showOccupancy() && occupancyRestrictions) {
					<vp-availability-widget-input-occupancy
						[className]="
							cn(
								'focus:relative focus:z-10',
								showHotels() &&
									'@max-sm:rounded-t-none @sm:rounded-l-none',
								(showPackages() || showDates()) &&
									'@max-sm:-mb-px @max-sm:rounded-b-none @sm:-mr-px @sm:rounded-r-none'
							)
						"
						[ctaLabel]="
							showPackages() && packages()?.length > 1
								? 'global.choose-package'
								: 'global.choose-dates'
						"
						[defaultAdults]="defaultAdults"
						[initialOccupancy]="initialOccupancy"
						[isOpen]="isOccupancyOpen"
						[maxRooms]="occupancyRestrictions.maxOccupancies"
						[occupancyRestrictions]="occupancyRestrictions"
						(emitBackButton)="
							onBackButton(
								$event,
								showHotels(),
								false,
								false,
								false
							)
						"
						(emitCta)="
							onCtaEmit(
								$event,
								showPackages() && packages()?.length > 1
							)
						"
						(emitIsPopoverOpen)="onOccupancyOpenEmit($event)"
						(occupancyChanged)="onOccupancyEmit($event)"
						data-test-id="occupancy-selector"
					/>
				}
				@if (showPackages() && packages()?.length > 0) {
					<vp-availability-widget-input-dropdown
						[className]="
							cn(
								'focus:relative focus:z-10',
								(showHotels() || showOccupancy()) &&
									'@max-sm:rounded-t-none @sm:rounded-l-none',
								showDates() &&
									'@max-sm:-mb-px @max-sm:rounded-b-none @sm:-mr-px @sm:rounded-r-none'
							)
						"
						[items]="packages()"
						[label]="'global.package-label' | translate"
						[placeholder]="
							'global.package-selection-placeholder' | translate
						"
						[(isOpen)]="isPackagesOpen"
						[(selectedItem)]="selectedPackage"
						(emitBackButton)="
							onBackButton(
								$event,
								showHotels(),
								showOccupancy(),
								false,
								false
							)
						"
						(emitCta)="onCtaEmit($event)"
						(itemSelected)="onPackageSelect($event)"
						data-test-id="package-selector"
						inputName="availability-packages"
					/>
				}
				@if (showDates()) {
					<vp-availability-widget-input-date-range
						[availability]="availability$ | async"
						[className]="
							cn(
								'focus:md:border-l',
								(showPackages() ||
									showHotels() ||
									showOccupancy()) &&
									'@max-sm:rounded-t-none @sm:rounded-l-none'
							)
						"
						[config]="{
							mode: 'range',
							showMonths: 2,
							minDate: minDate,
							maxDate: maxDate,
						}"
						[currency]="currency()"
						[hideRangePrices]="forceHideRangePrices()"
						[initialArrivalDate]="initialArrivalDate"
						[initialDepartureDate]="initialDepartureDate"
						[isLoading]="isLoading"
						[isOpen]="isDatePickerOpen"
						[jumpToFirstAvailableDate]="jumpToFirstAvailableDate"
						[numberOfNights]="
							(showPackages() && selectedPackage().nights) ||
							(stepperConfig?.useStepper && nights)
						"
						[resetDateRange]="_resetDateRange"
						[showPrices]="showPrices()"
						[stepperConfig]="stepperConfig"
						(datePickerModelChanged)="updateModel($event)"
						(emitAvailabilityButton)="goToBookingtool()"
						(emitBackButton)="
							onBackButton(
								$event,
								showHotels(),
								showPackages() && packages()?.length > 1
									? false
									: showOccupancy(),
								showPackages() && packages()?.length > 1,
								false
							)
						"
						(emitIsPopoverOpen)="onDatePickerOpened($event)"
						(emitMonthChange)="onMonthChange($event)"
						(initialDatesNotAvailable)="
							recalculateAvailabilityForToday()
						"
						(stepperUpdated)="onStepperUpdated($event)"
						data-test-id="dates-selector"
					/>
				}
			</div>
			<button
				[disabled]="showHotels() && !selectedHotel"
				(click)="goToBookingtool()"
				class="btn btn-primary w-full @md:h-auto @lg:w-fit"
				data-test-id="cta-button"
			>
				{{ 'global.show-availability' | translate }}
			</button>
		</div>
	</div>
</div>
